export default __webpack_public_path__ + "static/media/checked-checkbox.5ac79a08.svg";